import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { EnableDialogComponent } from '../enable-dialog/enable-dialog.component';
@Component({
  selector: 'mifosx-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss']
})
export class ReceiptDialogComponent implements OnInit {

   dialogData: any;
   receiptUrl: any;
   /**
   * @param {MatDialogRef} dialogRef Component reference to dialog.
   * @param {any} data Provides a enableContext.
   */
    constructor(public dialogRef: MatDialogRef<EnableDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private sanitizer: DomSanitizer) {
        this.dialogData = data;

       }
  
    ngOnInit() {
      const filecontent = URL.createObjectURL(this.dialogData);
      this.receiptUrl = this.sanitizer.bypassSecurityTrustResourceUrl(filecontent);
    }

    closeDialog(){
      this.dialogRef.close('Closed');
    }

}